import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gamename'
})
export class GamenamePipe implements PipeTransform {
  games = [
    {type: 'teen20', name:'Teenpatti20'},
    {type: 'teen8', name: "Teenpatti Open"},
    {type: 'teen9', name: "Teenpatti Test"},
    {type: 'Teen', name: "Teenpatti Oneday"},
    {type: 'dt20', name:'DragonTiger'},
    {type: 'dt202', name: "DragonTiger2"},
    {type: 'dtl20', name: "DragonLionTiger20"},
    {type: 'dt6', name: "DragonTiger Oneday"},
    {type: 'lucky7', name: "Lucky7A"},
    {type: 'lucky7eu', name: "Lucky7B"},
    {type: 'card32', name: "Card32A"},
    {type: 'card32eu', name: "Card32B"},
    {type: 'abj', name: "AndarBahar2"},
    {type: 'ab20', name: "AndarBahar"},
    {type: 'aaa', name: "AmarAkbarAnthony"},
    {type: 'poker20', name: "Poker20"},
    {type: 'poker', name: "Poker Oneday"},
    {type: 'poker9', name: "Poker 6Player"},
    {type: 'baccarat', name: "Baccarat1"},
    {type: 'baccarat2', name: "Baccarat2"},
  ]
  transform(value: unknown, ...args: unknown[]): unknown {
    let r = this.games.filter((game: any) => {
      if (game.type == value) {
        return game.name
      }
    })
    return r[0].name;
  }

}
